import React, { FC, useRef } from 'react'
import { Typography, Carousel, Button } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import type { ListingMarker } from './Listings'

const { Text } = Typography

const POPUP_WIDTH = 280

interface ListingPopupProps {
  listing: ListingMarker
  hostSlot?: React.ReactNode
}

const ListingPopup: FC<ListingPopupProps> = ({ listing, hostSlot }) => {
  const carouselRef = useRef<any>(null)

  return (
    <div style={{ width: POPUP_WIDTH }}>
      {listing.images.length > 0 && (
        <div style={{ position: 'relative' }}>
          <Carousel ref={carouselRef} dots dotPosition='bottom'>
            {listing.images.map((img, i) => (
              <div key={i}>
                <img
                  src={img}
                  alt={listing.title}
                  style={{
                    width: '100%',
                    height: 180,
                    objectFit: 'cover',
                    borderRadius: '2px 2px 0 0',
                    display: 'block',
                  }}
                />
              </div>
            ))}
          </Carousel>
          {listing.images.length > 1 && (
            <>
              <Button
                size='small'
                shape='circle'
                icon={<LeftOutlined style={{ fontSize: 10 }} />}
                onClick={e => {
                  e.stopPropagation()
                  carouselRef.current?.prev()
                }}
                style={{
                  position: 'absolute',
                  top: '40%',
                  left: 8,
                  transform: 'translateY(-50%)',
                  zIndex: 10,
                  background: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                }}
              />
              <Button
                size='small'
                shape='circle'
                icon={<RightOutlined style={{ fontSize: 10 }} />}
                onClick={e => {
                  e.stopPropagation()
                  carouselRef.current?.next()
                }}
                style={{
                  position: 'absolute',
                  top: '40%',
                  right: 8,
                  transform: 'translateY(-50%)',
                  zIndex: 10,
                  background: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                }}
              />
            </>
          )}
        </div>
      )}

      <div style={{ padding: '16px 24px', border: '1px solid #F0F0F0', borderTop: 'none', borderRadius: '0 0 2px 2px' }}>
        <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 12 }}>
          {listing.title}
        </Text>

        <div>
          {hostSlot}
          <Text type='secondary' style={{ fontSize: 14, display: 'block', marginBottom: 4 }}>
            Estimated revenue : <Text style={{ fontSize: 14 }}>${listing.estimatedRevenue.toLocaleString()}</Text>
          </Text>
          {listing.numberOfReviews != null && (
            <Text type='secondary' style={{ fontSize: 14, display: 'block' }}>
              Number Of Reviews : <Text style={{ fontSize: 14 }}>{listing.numberOfReviews.toLocaleString()}</Text>
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}

export default ListingPopup
